import * as React from "react";
import * as Loadable from "react-loadable";
import { BrowserRouter as Router, Redirect, Switch } from "react-router-dom";

import { NotFoundScreen } from "../static/NotFoundScreen";
import { InitialLoadingScreen } from "./InitialLoadingScreen";
import NavigationConstants from "./NavigationConstants";
import SLRoute from "./SLRoute";
import FormQuickApplication from "../Forms/screens/FormQuickApplication/FormQuickApplication";
import {ExpiredOfferScreen} from "../static/ExpiredOfferScreen";
import FormSBAContainer from "../Forms/screens/FormSBA/FormSBAContainer";
import FormManageLoanPlanContainer from "../Forms/screens/FormManageLoanPlan/FormManageLoanPlanContainer";
import FormConnectBankContainer from "../Forms/screens/FormConnectBank/FormConnectBankContainer";

const AsyncFinishSignUp = Loadable({
  loader: () => import("../FinishSignUp/FinishSignUpContainer"),
  loading: InitialLoadingScreen
});

const AsyncDashboard = Loadable({
  loader: () => import("../Dashboard/DashboardSceneContainer"),
  loading: InitialLoadingScreen
});

const AsyncAuthentication = Loadable({
  loader: () => import("../Authentication/AuthenticationSceneContainer"),
  loading: InitialLoadingScreen
});

const AsyncAdmin = Loadable({
  loader: () => import("../Admin/AdminScene"),
  loading: InitialLoadingScreen
});

const AsyncMembersChat = Loadable({
  loader: () => import("../Bots/Members/MembersBotContainer"),
  loading: InitialLoadingScreen
});

const partnersRedirect = () => <Redirect to={NavigationConstants.partners} />;

const AsyncPartnersChat = Loadable({
  loader: () => import("../Bots/Partners/PartnersBotContainer"),
  loading: InitialLoadingScreen
});

const AsyncGenericBot = Loadable({
  loader: () => import("../Bots/Generic/GenericBotContainer"),
  loading: InitialLoadingScreen
});

const AsyncReferrals = Loadable({
  loader: () => import("../Referrals/ReferralsContainer"),
  loading: InitialLoadingScreen
});

const AsyncActions = Loadable({
  loader: () => import("../Actions/ActionsPageContainer"),
  loading: InitialLoadingScreen
});

// const AsyncConnectPlaid = Loadable({
//   loader: () => import("../Plaid/ConnectPlaidContainer"),
//   loading: InitialLoadingScreen
// });

const AsyncGetCoverageBot = Loadable({
  loader: () => import("../Bots/GetCoverage/GetCoverageBotContainer"),
  loading: InitialLoadingScreen
});

const MyAccount = Loadable({
  loader: () => import("../MyAccount/MyAccountContainer"),
  loading: InitialLoadingScreen
});

const lendioSignUpForm = Loadable({
  loader: () => import("../Forms/screens/FormLendio/FormLendio"),
  loading: InitialLoadingScreen
});

const addCoverage = Loadable({
  loader: () => import("../Forms/screens/FormAddCoverage/FormAddCoverage"),
  loading: InitialLoadingScreen
});

const upgradePlan = Loadable({
  loader: () => import("../Forms/screens/FormUpgradePlan/FormUpgradePlan"),
  loading: InitialLoadingScreen
});

const cancelPlan = Loadable({
  loader: () => import("../Forms/screens/FormCancel/FormCancel"),
  loading: InitialLoadingScreen
});


const brokers = Loadable({
  loader: () => import("../Forms/screens/FormBrokers/FormBrokers"),
  loading: InitialLoadingScreen
});

const payments = Loadable({
  loader: () => import("../Forms/screens/FormPayments/FormPayments"),
  loading: InitialLoadingScreen
});

const PendingLeadScreen = Loadable({
  loader: () => import("../static/PendingLeadScreen"),
  loading: InitialLoadingScreen
});

const ThankYouScreen = Loadable({
  loader: () => import("../static/ThankYouScreen"),
  loading: InitialLoadingScreen
});
/*

      <SLRoute
        path={NavigationConstants.partners}
        component={AsyncPartnersChat}
      />

*/
const MainNavigator = () => (
  <Router>
    <Switch>
      <Redirect from={NavigationConstants.signUp} to={NavigationConstants.businessLoan} />
      <SLRoute
        path={NavigationConstants.genericBot}
        component={AsyncGenericBot}
      />
      <SLRoute
        path={NavigationConstants.members}
        component={AsyncMembersChat}
      />
      <SLRoute
          authed={true}
          exact={true}
          path={NavigationConstants.myAccount}
          component={MyAccount}
      />
      <SLRoute
        path={NavigationConstants.referrals}
        component={AsyncReferrals}
      />
      <SLRoute
        path={NavigationConstants.actionsPage}
        component={AsyncActions}
      />
      <SLRoute
        authed={true}
        desktopOnly={true}
        exact={true}
        path={NavigationConstants.oldDashboard}
        component={AsyncDashboard}
        mobileComponent={partnersRedirect}
      />
      <SLRoute
          path={NavigationConstants.login}
        component={AsyncAuthentication}
      />
      <SLRoute
          path={NavigationConstants.finishSignUp}
        component={AsyncFinishSignUp}
      />
      <SLRoute
        path={NavigationConstants.connectPlaid}
        component={FormConnectBankContainer}
      />
      <SLRoute
        path={NavigationConstants.sbaLoan}
        component={FormSBAContainer}
      />
      <SLRoute
        path={NavigationConstants.getCoverage}
        component={AsyncGetCoverageBot}
      />
      <SLRoute
        desktopOnly={true}
        path={NavigationConstants.notFound404}
        component={NotFoundScreen}
      />
      <SLRoute
          path={NavigationConstants.offerExpired}
          component={ExpiredOfferScreen}
      />
      <SLRoute
        authed={true}
        desktopOnly={true}
        path={NavigationConstants.admin}
        component={AsyncAdmin}
      />
      <SLRoute
          path={NavigationConstants.shortSignup}
          component={lendioSignUpForm}
      />
      <SLRoute
          path={NavigationConstants.businessLoan}
          component={FormQuickApplication}
      />
      <SLRoute
          path={NavigationConstants.quickRent}
          component={FormQuickApplication}
      />
        <SLRoute
            authed={true}
            path={NavigationConstants.addCoverage}
            component={addCoverage}
        />
        <SLRoute
            path={NavigationConstants.managePlan}
            component={upgradePlan}
        />

      <SLRoute
          path={NavigationConstants.manageLoan}
          component={FormManageLoanPlanContainer}
      />

        <SLRoute
            path={NavigationConstants.cancelPlan}
            component={cancelPlan}
        />

        <SLRoute
            path={NavigationConstants.partners}
            component={AsyncPartnersChat}
        />

        <SLRoute
            path={NavigationConstants.brokers}
            component={brokers}
        />

        <SLRoute
            path={NavigationConstants.payments}
            component={payments}
        />

        <SLRoute
            path={NavigationConstants.pendingLead}
            component={PendingLeadScreen}
        />

        <SLRoute
            path={NavigationConstants.thankYou}
            component={ThankYouScreen}
        />
        <SLRoute
          authed={true}
          exact={true}
          path={NavigationConstants.homePageRoute}
          component={MyAccount}
        />

      <Redirect to={NavigationConstants.notFound404} />
    </Switch>
  </Router>
);

export default MainNavigator;



// WEBPACK FOOTER //
// ./src/scenes/Navigation/MainNavigator.tsx